<template>
  <section>
    <Fieldset
      :legend="translate('additional informations', 'ucfirst')"
    class="w-full px-5 pb-4 mt-5 bg-white rounded-lg shadow-md border border-color-iron"
    >
      <Skeleton v-if="isLoading && additionalInfo" height="1.5rem"></Skeleton>
      <ul
        v-else-if="!isLoading && additionalInfo.length > 0"
        class="list-inside list-disc"
      > 
        <li v-for="(information, index) in additionalInfo" :key="index">
        {{ information.value }}
        </li> 
      </ul>
      <ul v-else>
        <li>{{ translate("no additional information", "ucfirst") }}</li>
      </ul>
    </Fieldset>
  </section>
</template>

<script setup>
import { ref, onMounted, onUpdated } from "vue";
import Fieldset from "primevue/fieldset";
import Skeleton from "primevue/skeleton";
import { translate } from "@/composables/translate";


const props = defineProps({
  addInformation: {
    type: Array,
    required: true,
    default: ()=> []
  }
});

let additionalInfo = ref([]);
let isLoading = ref(false);


onUpdated(() => {
  isLoading.value = false
  if (props.addInformation.length > 0 ) additionalInfo.value = props.addInformation
})

onMounted(() => {
  isLoading.value = true
});
</script>